export interface ComicChapter {
  id: string;
  number: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  tags: string[];
  updateDate: string;
  totalChapters: number;
  rating: number;
  views: number;
  status: 'completed' | 'ongoing';
  chapters: ComicChapter[];
}

export const categories = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'slice-of-life', name: '日常', icon: 'ri-sun-line' },
];

export const comics: Comic[] = [
  {
    id: 'my-sassy-girl',
    title: '我的野蛮女友',
    author: '金浩植',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20manhwa%20cover%2C%20young%20couple%20in%20modern%20Seoul%20street%2C%20warm%20pink%20and%20peach%20tones%2C%20soft%20lighting%2C%20romantic%20atmosphere%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-01&orientation=portrait',
    description: '一个是霸道任性的她，一个是温柔包容的他。一段始于校园的甜蜜爱情故事，两个性格迥异的年轻人，在磕磕绊绊中慢慢靠近彼此，演绎出一段令人心动的浪漫恋曲。',
    category: 'romance',
    tags: ['恋爱', '校园', '甜宠', '搞笑'],
    updateDate: '2026-08-04',
    totalChapters: 128,
    rating: 4.8,
    views: 1850000,
    status: 'ongoing',
    chapters: [
      { id: 'msg-128', number: 128, title: '最终章：我们的故事', updateDate: '2026-08-04' },
      { id: 'msg-127', number: 127, title: '新的开始', updateDate: '2026-07-28' },
      { id: 'msg-126', number: 126, title: '意外的告白', updateDate: '2026-07-21' },
      { id: 'msg-125', number: 125, title: '雨中的约定', updateDate: '2026-07-14' },
      { id: 'msg-124', number: 124, title: '生日惊喜', updateDate: '2026-07-07' },
    ],
  },
  {
    id: 'goddess-descends',
    title: '女神降临',
    author: '猫咪',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20beauty%20makeover%20manhwa%20cover%2C%20transformed%20girl%20with%20makeup%20looking%20in%20mirror%2C%20soft%20glamorous%20lighting%2C%20peach%20and%20rose%20tones%2C%20clean%20illustration%2C%20white%20minimal%20background&width=600&height=800&seq=comic-02&orientation=portrait',
    description: '一个因为外貌而自卑的女孩，通过化妆术蜕变为校园女神。然而完美的表象之下，隐藏着不为人知的秘密与挣扎。当真相被揭开，她能否找到真正的自己？',
    category: 'romance',
    tags: ['恋爱', '校园', '美妆', '成长'],
    updateDate: '2026-08-03',
    totalChapters: 186,
    rating: 4.9,
    views: 3250000,
    status: 'completed',
    chapters: [
      { id: 'gd-186', number: 186, title: '真正的美丽（完结）', updateDate: '2026-07-15' },
      { id: 'gd-185', number: 185, title: '最后的舞台', updateDate: '2026-07-08' },
      { id: 'gd-184', number: 184, title: '选择', updateDate: '2026-07-01' },
      { id: 'gd-183', number: 183, title: '真心话', updateDate: '2026-06-24' },
    ],
  },
  {
    id: 'sweet-trap',
    title: '甜蜜的陷阱',
    author: '李恩珠',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20drama%20manhwa%20cover%2C%20elegant%20woman%20and%20man%20in%20office%20setting%2C%20soft%20rose%20and%20cream%20tones%2C%20romantic%20suspense%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-03&orientation=portrait',
    description: '职场女强人林晓薇意外陷入了一场精心设计的感情陷阱。她以为遇到了真命天子，却发现一切都是计划好的骗局。爱与恨之间，她该如何抉择？',
    category: 'romance',
    tags: ['恋爱', '职场', '商战', '复仇'],
    updateDate: '2026-08-05',
    totalChapters: 72,
    rating: 4.6,
    views: 890000,
    status: 'ongoing',
    chapters: [
      { id: 'st-72', number: 72, title: '真相大白', updateDate: '2026-08-05' },
      { id: 'st-71', number: 71, title: '最后一张牌', updateDate: '2026-07-29' },
      { id: 'st-70', number: 70, title: '反击开始', updateDate: '2026-07-22' },
    ],
  },
  {
    id: 'confession-diary',
    title: '告白日记',
    author: '韩智敏',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20romance%20manhwa%20cover%2C%20shy%20girl%20holding%20love%20letter%20in%20classroom%2C%20cherry%20blossom%20petals%2C%20soft%20pink%20warm%20lighting%2C%20clean%20illustration%2C%20white%20background&width=600&height=800&seq=comic-04&orientation=portrait',
    description: '高中女生小樱暗恋学长三年，终于鼓起勇气写下告白日记。每一页都是她的心跳，每一行都是她的思念。这本日记，能否传递她最真挚的心意？',
    category: 'romance',
    tags: ['恋爱', '校园', '青春', '纯爱'],
    updateDate: '2026-08-01',
    totalChapters: 56,
    rating: 4.7,
    views: 720000,
    status: 'ongoing',
    chapters: [
      { id: 'cd-56', number: 56, title: '樱花树下的答案', updateDate: '2026-08-01' },
      { id: 'cd-55', number: 55, title: '最后一页', updateDate: '2026-07-25' },
      { id: 'cd-54', number: 54, title: '学长知道了', updateDate: '2026-07-18' },
    ],
  },
  {
    id: 'isekai-adventure',
    title: '异世界冒险谭',
    author: '朴志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20adventure%20manhwa%20cover%2C%20young%20warrior%20with%20sword%20in%20magical%20forest%2C%20warm%20amber%20and%20gold%20tones%2C%20epic%20atmosphere%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-05&orientation=portrait',
    description: '普通上班族李浩宇意外穿越到剑与魔法的异世界。在这里，他发现自己拥有独一无二的能力。与伙伴们一起，踏上拯救世界的冒险之旅！',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '穿越', '战斗'],
    updateDate: '2026-08-03',
    totalChapters: 210,
    rating: 4.7,
    views: 2560000,
    status: 'ongoing',
    chapters: [
      { id: 'ia-210', number: 210, title: '最终决战前夕', updateDate: '2026-08-03' },
      { id: 'ia-209', number: 209, title: '龙之峡谷', updateDate: '2026-07-27' },
      { id: 'ia-208', number: 208, title: '援军抵达', updateDate: '2026-07-20' },
    ],
  },
  {
    id: 'dragon-heir',
    title: '龙之继承者',
    author: '崔明秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20dragon%20manhwa%20cover%2C%20boy%20with%20dragon%20mark%20on%20hand%2C%20floating%20in%20ancient%20temple%2C%20warm%20gold%20and%20amber%20lighting%2C%20clean%20illustration%2C%20white%20background&width=600&height=800&seq=comic-06&orientation=portrait',
    description: '少年陈枫意外觉醒了龙族血脉，成为千年来第一位龙之继承者。在各方势力的追逐与争夺中，他必须快速成长，保护身边的人，揭开龙族陨落的真相。',
    category: 'fantasy',
    tags: ['奇幻', '龙族', '成长', '战斗'],
    updateDate: '2026-07-30',
    totalChapters: 145,
    rating: 4.5,
    views: 1680000,
    status: 'ongoing',
    chapters: [
      { id: 'dh-145', number: 145, title: '龙神试炼', updateDate: '2026-07-30' },
      { id: 'dh-144', number: 144, title: '远古遗迹', updateDate: '2026-07-23' },
      { id: 'dh-143', number: 143, title: '新的力量', updateDate: '2026-07-16' },
    ],
  },
  {
    id: 'magic-academy',
    title: '魔法学院',
    author: '尹秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20magic%20school%20manhwa%20cover%2C%20students%20casting%20spells%20in%20magical%20academy%20hallway%2C%20warm%20amber%20glowing%20magic%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-07&orientation=portrait',
    description: '平凡少女安琪收到了一封来自神秘魔法学院的录取通知书。没有魔法天赋的她，将如何在这个充满魔法与奇迹的世界中立足？一段关于友情、勇气与成长的魔法故事。',
    category: 'fantasy',
    tags: ['奇幻', '魔法', '学院', '友情'],
    updateDate: '2026-08-02',
    totalChapters: 98,
    rating: 4.6,
    views: 1230000,
    status: 'ongoing',
    chapters: [
      { id: 'ma-98', number: 98, title: '魔法大比', updateDate: '2026-08-02' },
      { id: 'ma-97', number: 97, title: '特训开始', updateDate: '2026-07-26' },
      { id: 'ma-96', number: 96, title: '隐藏的天赋', updateDate: '2026-07-19' },
    ],
  },
  {
    id: 'shadow-hunter',
    title: '暗影猎人',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20dark%20fantasy%20hunter%20manhwa%20cover%2C%20hooded%20figure%20with%20dual%20daggers%20in%20shadow%2C%20warm%20dark%20amber%20and%20brown%20tones%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-08&orientation=portrait',
    description: '在人类世界之下，隐藏着一个充满魔物的暗影界。少年影作为猎人家族的末裔，继承了猎杀魔物的使命。黑暗中的战斗，永不停止。',
    category: 'fantasy',
    tags: ['奇幻', '暗黑', '猎人', '战斗'],
    updateDate: '2026-07-28',
    totalChapters: 167,
    rating: 4.4,
    views: 1450000,
    status: 'ongoing',
    chapters: [
      { id: 'sh-167', number: 167, title: '暗影之王', updateDate: '2026-07-28' },
      { id: 'sh-166', number: 166, title: '最后的猎人', updateDate: '2026-07-21' },
      { id: 'sh-165', number: 165, title: '家族秘密', updateDate: '2026-07-14' },
    ],
  },
  {
    id: 'fist-king',
    title: '拳皇之路',
    author: '朴正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20martial%20arts%20action%20manhwa%20cover%2C%20fighter%20with%20wrapped%20fists%20in%20boxing%20ring%2C%20intense%20warm%20lighting%2C%20dynamic%20pose%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-09&orientation=portrait',
    description: '曾是街头混混的高中生金泰成，为了守护心爱之人，踏上了职业格斗之路。从地下拳场到世界冠军，他的拳头，只为保护而挥舞。',
    category: 'action',
    tags: ['动作', '格斗', '热血', '成长'],
    updateDate: '2026-08-04',
    totalChapters: 193,
    rating: 4.6,
    views: 2780000,
    status: 'ongoing',
    chapters: [
      { id: 'fk-193', number: 193, title: '世界冠军赛', updateDate: '2026-08-04' },
      { id: 'fk-192', number: 192, title: '最后的训练', updateDate: '2026-07-28' },
      { id: 'fk-191', number: 191, title: '宿敌登场', updateDate: '2026-07-21' },
    ],
  },
  {
    id: 'gang-secret',
    title: '黑帮密令',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20crime%20action%20manhwa%20cover%2C%20man%20in%20black%20suit%20standing%20in%20rainy%20alley%2C%20noir%20warm%20brown%20tones%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-10&orientation=portrait',
    description: '卧底警察姜宇潜入首尔最大黑帮组织，步步惊心。在黑白两道之间游走，每一次抉择都关乎生死。当忠诚与正义冲突，他该如何选择？',
    category: 'action',
    tags: ['动作', '黑帮', '卧底', '犯罪'],
    updateDate: '2026-08-01',
    totalChapters: 88,
    rating: 4.8,
    views: 1560000,
    status: 'ongoing',
    chapters: [
      { id: 'gs-88', number: 88, title: '身份暴露', updateDate: '2026-08-01' },
      { id: 'gs-87', number: 87, title: '最后任务', updateDate: '2026-07-25' },
      { id: 'gs-86', number: 86, title: '叛徒', updateDate: '2026-07-18' },
    ],
  },
  {
    id: 'ultimate-weapon',
    title: '终极兵器',
    author: '李俊赫',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20sci%20fi%20action%20manhwa%20cover%2C%20cyborg%20soldier%20with%20mechanical%20arm%2C%20futuristic%20city%20background%2C%20warm%20metallic%20tones%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-11&orientation=portrait',
    description: '近未来，人类研制出了被称为"终极兵器"的强化战士。编号K-07的少年从实验室逃脱，在逃亡中逐渐发现自己不仅是兵器，更是人类最后的希望。',
    category: 'action',
    tags: ['动作', '科幻', '机甲', '逃亡'],
    updateDate: '2026-07-29',
    totalChapters: 134,
    rating: 4.5,
    views: 1320000,
    status: 'ongoing',
    chapters: [
      { id: 'uw-134', number: 134, title: '自由之日', updateDate: '2026-07-29' },
      { id: 'uw-133', number: 133, title: '最终兵器启动', updateDate: '2026-07-22' },
      { id: 'uw-132', number: 132, title: '反击', updateDate: '2026-07-15' },
    ],
  },
  {
    id: 'street-king',
    title: '街头霸主',
    author: '赵敏基',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20street%20fighting%20action%20manhwa%20cover%2C%20teenager%20in%20school%20uniform%20fighting%20pose%20in%20urban%20street%2C%20warm%20orange%20sunset%20lighting%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-12&orientation=portrait',
    description: '转学生张浩来到以打架闻名的风云高中，第一天就挑战了学校最强的霸主。在这个弱肉强食的世界里，他用拳头建立自己的秩序。',
    category: 'action',
    tags: ['动作', '校园', '格斗', '热血'],
    updateDate: '2026-07-25',
    totalChapters: 201,
    rating: 4.4,
    views: 2100000,
    status: 'completed',
    chapters: [
      { id: 'sk-201', number: 201, title: '新的传说（完结）', updateDate: '2026-06-20' },
      { id: 'sk-200', number: 200, title: '最终的胜者', updateDate: '2026-06-13' },
      { id: 'sk-199', number: 199, title: '巅峰之战', updateDate: '2026-06-06' },
    ],
  },
  {
    id: 'seventh-night',
    title: '第七个夜晚',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20thriller%20manhwa%20cover%2C%20woman%20looking%20through%20window%20at%20night%20with%20moonlight%2C%20mysterious%20warm%20dark%20atmosphere%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-13&orientation=portrait',
    description: '每七天，就有一人神秘失踪。刑警韩秀敏调查连环失踪案时，发现所有线索都指向一个诡异的数字——七。第七个夜晚，真相终将浮出水面。',
    category: 'thriller',
    tags: ['悬疑', '推理', '犯罪', '惊悚'],
    updateDate: '2026-08-05',
    totalChapters: 64,
    rating: 4.9,
    views: 1980000,
    status: 'ongoing',
    chapters: [
      { id: 'sn-64', number: 64, title: '第七人', updateDate: '2026-08-05' },
      { id: 'sn-63', number: 63, title: '倒数计时', updateDate: '2026-07-29' },
      { id: 'sn-62', number: 62, title: '第六个失踪者', updateDate: '2026-07-22' },
    ],
  },
  {
    id: 'escape-room',
    title: '密室逃脱',
    author: '朴敏英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20escape%20room%20thriller%20manhwa%20cover%2C%20people%20trapped%20in%20locked%20room%20with%20puzzle%20elements%2C%20tense%20warm%20dark%20lighting%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-14&orientation=portrait',
    description: '六名陌生人被关进一间密室，他们必须解开一系列谜题才能逃出生天。但随着谜题的深入，他们发现这场"游戏"背后隐藏着更大的阴谋。',
    category: 'thriller',
    tags: ['悬疑', '密室', '解谜', '生存'],
    updateDate: '2026-08-02',
    totalChapters: 42,
    rating: 4.7,
    views: 1120000,
    status: 'ongoing',
    chapters: [
      { id: 'er-42', number: 42, title: '最后的房间', updateDate: '2026-08-02' },
      { id: 'er-41', number: 41, title: '真相之门', updateDate: '2026-07-26' },
      { id: 'er-40', number: 40, title: '背叛者', updateDate: '2026-07-19' },
    ],
  },
  {
    id: 'vanished-her',
    title: '消失的她',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20psychological%20thriller%20manhwa%20cover%2C%20missing%20woman%20poster%20on%20wall%20with%20detective%20silhouette%2C%20warm%20dark%20suspenseful%20lighting%2C%20clean%20illustration%2C%20white%20background&width=600&height=800&seq=comic-15&orientation=portrait',
    description: '结婚五年的妻子突然消失了，没有留下任何痕迹。丈夫在寻找妻子的过程中，发现了一个又一个关于她的秘密。她到底是谁？又去了哪里？',
    category: 'thriller',
    tags: ['悬疑', '婚姻', '失踪', '心理'],
    updateDate: '2026-07-31',
    totalChapters: 55,
    rating: 4.8,
    views: 1670000,
    status: 'ongoing',
    chapters: [
      { id: 'vh-55', number: 55, title: '双重身份', updateDate: '2026-07-31' },
      { id: 'vh-54', number: 54, title: '目击者', updateDate: '2026-07-24' },
      { id: 'vh-53', number: 53, title: '照片中的她', updateDate: '2026-07-17' },
    ],
  },
  {
    id: 'deep-blue-eyes',
    title: '深蓝之眼',
    author: '姜东元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20supernatural%20thriller%20manhwa%20cover%2C%20person%20with%20glowing%20blue%20eyes%20seeing%20ghosts%2C%20mysterious%20warm%20amber%20lighting%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-16&orientation=portrait',
    description: '车祸后，大学生林晨获得了看见死者最后记忆的能力。他利用这个能力帮助破案，却也逐渐卷入了一个横跨数十年的巨大阴谋之中。',
    category: 'thriller',
    tags: ['悬疑', '超能力', '破案', '灵异'],
    updateDate: '2026-07-27',
    totalChapters: 78,
    rating: 4.6,
    views: 1350000,
    status: 'ongoing',
    chapters: [
      { id: 'db-78', number: 78, title: '最后的记忆', updateDate: '2026-07-27' },
      { id: 'db-77', number: 77, title: '连环杀手', updateDate: '2026-07-20' },
      { id: 'db-76', number: 76, title: '二十年前的秘密', updateDate: '2026-07-13' },
    ],
  },
  {
    id: 'cat-cafe',
    title: '猫的咖啡馆',
    author: '金多美',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20slice%20of%20life%20cat%20cafe%20manhwa%20cover%2C%20cute%20cats%20in%20cozy%20cafe%20with%20barista%2C%20warm%20coffee%20tones%2C%20soft%20cozy%20lighting%2C%20clean%20illustration%2C%20white%20background&width=600&height=800&seq=comic-17&orientation=portrait',
    description: '辞职后的女主角继承了一家猫咪咖啡馆。在这里，她遇到了各色各样的客人和性格迥异的猫咪们。每一天都被温暖和治愈包围的日常故事。',
    category: 'slice-of-life',
    tags: ['日常', '治愈', '猫咪', '美食'],
    updateDate: '2026-08-03',
    totalChapters: 112,
    rating: 4.8,
    views: 980000,
    status: 'ongoing',
    chapters: [
      { id: 'cc-112', number: 112, title: '新来的小猫', updateDate: '2026-08-03' },
      { id: 'cc-111', number: 111, title: '雨天的客人', updateDate: '2026-07-27' },
      { id: 'cc-110', number: 110, title: '咖啡馆的夏天', updateDate: '2026-07-20' },
    ],
  },
  {
    id: 'living-alone',
    title: '独自生活',
    author: '朴素珍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20slice%20of%20life%20manhwa%20cover%2C%20young%20woman%20in%20cozy%20studio%20apartment%20cooking%2C%20warm%20homey%20lighting%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-18&orientation=portrait',
    description: '独自在首尔生活的25岁女生，记录下一个人吃饭、一个人逛街、一个人看电影的日常。虽然偶尔会感到孤独，但更多的是自由与成长的小确幸。',
    category: 'slice-of-life',
    tags: ['日常', '独居', '都市', '成长'],
    updateDate: '2026-08-04',
    totalChapters: 85,
    rating: 4.7,
    views: 1430000,
    status: 'ongoing',
    chapters: [
      { id: 'la-85', number: 85, title: '搬家日记', updateDate: '2026-08-04' },
      { id: 'la-84', number: 84, title: '一个人的生日', updateDate: '2026-07-28' },
      { id: 'la-83', number: 83, title: '深夜食堂', updateDate: '2026-07-21' },
    ],
  },
  {
    id: 'next-door-her',
    title: '隔壁的她',
    author: '郑彩娟',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20neighbor%20slice%20of%20life%20manhwa%20cover%2C%20two%20apartments%20side%20by%20side%20with%20connecting%20balcony%2C%20warm%20sunset%20lighting%2C%20clean%20illustration%20style%2C%20white%20background&width=600&height=800&seq=comic-19&orientation=portrait',
    description: '隔壁搬来了一个奇怪的邻居。她白天从不出门，半夜却能听到悠扬的钢琴声。好奇心驱使下，他开始了一场关于隔壁那个神秘她的探索之旅。',
    category: 'slice-of-life',
    tags: ['日常', '邻居', '治愈', '音乐'],
    updateDate: '2026-07-30',
    totalChapters: 67,
    rating: 4.6,
    views: 870000,
    status: 'ongoing',
    chapters: [
      { id: 'nd-67', number: 67, title: '钢琴二重奏', updateDate: '2026-07-30' },
      { id: 'nd-66', number: 66, title: '深夜的旋律', updateDate: '2026-07-23' },
      { id: 'nd-65', number: 65, title: '第一次对话', updateDate: '2026-07-16' },
    ],
  },
  {
    id: 'spring-letter',
    title: '春日来信',
    author: '李知晓',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20warm%20slice%20of%20life%20manhwa%20cover%2C%20girl%20reading%20letter%20under%20cherry%20blossom%20tree%20in%20spring%2C%20warm%20pink%20petal%20lighting%2C%20clean%20illustration%2C%20white%20background&width=600&height=800&seq=comic-20&orientation=portrait',
    description: '祖母去世后，女孩在整理遗物时发现了一封没有寄出的信。循着信中的线索，她踏上了一段穿越时光的旅程，重新连接起祖母年轻时的故事与自己的当下。',
    category: 'slice-of-life',
    tags: ['日常', '温情', '家族', '回忆'],
    updateDate: '2026-08-05',
    totalChapters: 38,
    rating: 4.9,
    views: 760000,
    status: 'ongoing',
    chapters: [
      { id: 'sl-38', number: 38, title: '最后一封信', updateDate: '2026-08-05' },
      { id: 'sl-37', number: 37, title: '重逢', updateDate: '2026-07-29' },
      { id: 'sl-36', number: 36, title: '旧照片', updateDate: '2026-07-22' },
    ],
  },
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter((c) => c.category === categorySlug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getFeaturedComics = (): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, 6);
};

export const getLatestUpdates = (): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);
};